export * from './breakpoints';
export * from './license';
export * from './regex';
export * from './sanitize';
export * from './error';
export * from './analytic';

export const NAV_OWNER = process.env.NEXT_PUBLIC_NAV_OWNER || 'fgc';

export const GIFT_CARD_CODE_LENGTH = 16;

export const FN_MERCHANT_GROUP = 'FN_MKT';

export const AXIOS_TIMEOUT = 15000;

export const APP_CONTEXT: string = process.env.NEXT_PUBLIC_APP_CONTEXT || '/redeem';

export const LOCAL_POSA_ASSETS_PATH = `${APP_CONTEXT}/posa/static/assets`;
